"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const newTabLinkButton_1 = require("components/cosmos/newTabLinkButton");
const translate_1 = require("components/translate");
const Settings_1 = __importDefault(require("configs/Settings"));
const mobx_react_1 = require("mobx-react");
const class_1 = require("modules/app/services/datahub/class");
const constants_1 = require("modules/classManager/constants");
const ModalClass_1 = __importDefault(require("modules/classManager/modalClass/ModalClass"));
const offerListDesktop_1 = require("./offerListDesktop");
const offerListMobile_1 = require("./offerListMobile");
const useTransferOfferAlert_1 = __importDefault(require("./useTransferOfferAlert"));
const Offers = ({ classId, productId, name, value, items, className, isMobile = false, onChange }) => {
    const [selectedOfferIds, setSelectedOfferIds] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        if (value.length > 0) {
            setSelectedOfferIds(value);
        }
    }, [value]);
    const handleAlertConfirm = (selectedTransferOffersIds) => {
        setSelectedOfferIds(selectedTransferOffersIds);
        onChange === null || onChange === void 0 ? void 0 : onChange({ target: { name, value: selectedTransferOffersIds } });
    };
    const { isAlertOpen, handleCloseAlert, handleConfirmAlert, showTransferOfferAlert } = (0, useTransferOfferAlert_1.default)({ onAlertConfirm: handleAlertConfirm });
    const showTransferAlert = (newSelectedOfferIds) => {
        if (!showTransferOfferAlert(value, newSelectedOfferIds)) {
            setSelectedOfferIds(newSelectedOfferIds);
            onChange === null || onChange === void 0 ? void 0 : onChange({ target: { name, value: newSelectedOfferIds } });
        }
    };
    const handleSelectAll = ({ target }) => {
        let newSelectedOfferIds = [];
        if (target.checked) {
            newSelectedOfferIds = items === null || items === void 0 ? void 0 : items.map((offer) => offer.key);
        }
        showTransferAlert(newSelectedOfferIds);
    };
    const handleSelect = ({ target }) => {
        const offerId = target.value;
        let newSelectedOfferIds = [...selectedOfferIds, offerId];
        if (!target.checked) {
            newSelectedOfferIds = newSelectedOfferIds.filter((selectedOfferId) => selectedOfferId !== offerId);
        }
        showTransferAlert(newSelectedOfferIds);
    };
    const handleOnClick = () => {
        class_1.DatahubClassService.sendCreateNewOfferEvent(classId);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: className, children: [(0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _flex-column _flex-md-row _justify-content-md-between _align-items-md-center", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("p", { className: "_font-weight-bold _line-height-lg", children: (0, jsx_runtime_1.jsx)(translate_1.I18n, { label: "class_manager.class_editor.associate_offers" }) }), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(translate_1.I18n, { label: "class_manager.class_editor.offers_tooltip" }) })] }), productId && ((0, jsx_runtime_1.jsx)(newTabLinkButton_1.NewTabLinkButton, { className: "_mt-3 _mt-sm-0 _align-self-end _align-self-md-center", label: "class_manager.class_editor.create_offer", href: `${Settings_1.default.app.bw}/products/manage/${productId}/offers`, onClick: handleOnClick }))] }), isMobile ? ((0, jsx_runtime_1.jsx)(offerListMobile_1.OfferListMobile, { className: "_mt-7", name: name, offers: items, selectedOfferIds: selectedOfferIds, onSelectAll: handleSelectAll, onSelect: handleSelect })) : ((0, jsx_runtime_1.jsx)(offerListDesktop_1.OfferListDesktop, { className: "_mt-7", name: name, offers: items, selectedOfferIds: selectedOfferIds, onSelectAll: handleSelectAll, onSelect: handleSelect })), isAlertOpen && ((0, jsx_runtime_1.jsx)(ModalClass_1.default, { type: constants_1.modalTypes.transferOffers.type, onCancel: handleCloseAlert, onConfirm: handleConfirmAlert }))] }));
};
exports.default = (0, mobx_react_1.inject)((store) => ({
    productId: store.MembershipStore.marketplaceId,
    isMobile: store.UiStore.isMobile
}))(Offers);
